module.exports = __webpack_public_path__ + "00f76fe79141bb2c45263aa37255ac62.svg";